import createIcon from '../../createIcon';

/**
 * @component @name WifiLock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuOTggMTAuNUwyNCA4LjQ4QzIwLjkzIDUuNCAxNi42OSAzLjUgMTIgMy41QzcuMzEgMy41IDMuMDcgNS40IDAgOC40OEwxMiAyMC41TDE1LjA1IDE3LjQ1VjE0LjVDMTUuMDUgMTQuMDUgMTUuMTQgMTMuNjIgMTUuMjggMTMuMjFDMTUuODIgMTEuNjQgMTcuMjkgMTAuNSAxOS4wNSAxMC41SDIxLjk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIyIDE1LjVWMTQuNUMyMiAxMy40IDIxLjEgMTIuNSAyMCAxMi41QzE4LjkgMTIuNSAxOCAxMy40IDE4IDE0LjVWMTUuNUMxNy40NSAxNS41IDE3IDE1Ljk1IDE3IDE2LjVWMTkuNUMxNyAyMC4wNSAxNy40NSAyMC41IDE4IDIwLjVIMjJDMjIuNTUgMjAuNSAyMyAyMC4wNSAyMyAxOS41VjE2LjVDMjMgMTUuOTUgMjIuNTUgMTUuNSAyMiAxNS41Wk0yMSAxNS41SDE5VjE0LjVDMTkgMTMuOTUgMTkuNDUgMTMuNSAyMCAxMy41QzIwLjU1IDEzLjUgMjEgMTMuOTUgMjEgMTQuNVYxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiLock = createIcon('WifiLock', [
  [
    'path',
    {
      d: 'M21.98 10.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L15.05 17.45V14.5C15.05 14.05 15.14 13.62 15.28 13.21C15.82 11.64 17.29 10.5 19.05 10.5H21.98Z',
      key: '1rkvpf',
    },
  ],
  [
    'path',
    {
      d: 'M22 15.5V14.5C22 13.4 21.1 12.5 20 12.5C18.9 12.5 18 13.4 18 14.5V15.5C17.45 15.5 17 15.95 17 16.5V19.5C17 20.05 17.45 20.5 18 20.5H22C22.55 20.5 23 20.05 23 19.5V16.5C23 15.95 22.55 15.5 22 15.5ZM21 15.5H19V14.5C19 13.95 19.45 13.5 20 13.5C20.55 13.5 21 13.95 21 14.5V15.5Z',
      key: 'r7ifmv',
    },
  ],
]);

export default WifiLock;
